import styled from 'styled-components';

export const SkeletonWrapper = styled.div`
  flex-grow: 1;
  padding: 16px;
`;

export const SKELETON_AREAS = [
  {
    styles: {
      width: '100%',
      height: '100%',
      borderRadius: '8px',
    },
  },
];
